import { formatPrice } from '../../utils/priceFormatter';

const ProductPriceCard = ({ 
  productPrice = 0,
  isDarkMode,
  selectedVariant
}) => {
  // Use selected variant price if available, otherwise use product price
  const displayPrice = selectedVariant?.price ?? productPrice;
  
  if (!displayPrice || displayPrice === 0) return null;
  
  return (
    <div className={`sm:block p-0 md:p-5 mb-4 rounded-xl ${
      isDarkMode 
        ? 'bg-gradient-to-r from-gray-700 to-gray-800 border border-gray-600' 
        : 'bg-gradient-to-r from-emerald-50 to-green-50 border border-emerald-100'
    }`}>
      <div className="flex flex-col items-center justify-between md:flex-row">
        <div className="flex items-center gap-2">
          <p className={`text-sm font-medium ${isDarkMode ? 'text-gray-300' : 'text-gray-600'}`}>
            Get Up To
          </p>
        </div>
        <div className="flex items-baseline mt-2 md:mt-0">
          <span className={`ml-1 text-4xl md:text-5xl font-bold ${
            isDarkMode ? 'text-white' : 'text-emerald-700'
          }`}>
            {formatPrice(displayPrice, { symbol: false })}
          </span>
        </div>
      </div>
      
      {/* Show variant title if selected */}
      {selectedVariant && selectedVariant.title && (
        <div className="mt-2 text-center md:text-left">
          <p className={`text-xs ${isDarkMode ? 'text-gray-400' : 'text-gray-500'}`}>
            {selectedVariant.title}
          </p>
        </div>
      )}
    </div>
  );
};

export default ProductPriceCard;